
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ExchangeGrid extends Serenity.EntityGrid<ExchangeRow, any> {
        protected getColumnsKey() { return 'Retail.Exchange'; }
        protected getDialogType() { return ExchangeDialog; }
        protected getIdProperty() { return ExchangeRow.idProperty; }
        protected getInsertPermission() { return ExchangeRow.insertPermission; }
        protected getLocalTextPrefix() { return ExchangeRow.localTextPrefix; }
        protected getService() { return ExchangeService.baseUrl; } 
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            
            let now = new Date(); 
            var voucherNo = FormatHelper.GetVoucherNo(50);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[50].AutoPosting;
            this.editItem(<ExchangeRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 50,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions(); 
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}